// Definition of AntDesign Constants

export default {
    theme: {
        token: {
            colorPrimary: '#fcbf00',
            fontFamily: 'IRANSansFaNum, Tahoma, Arial, sans-serif'
        },
    }
};
